/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overflow_Analysis_Range_WarningInputs */

const en_us2_overflow_analysis_range_warning = /** @type {(inputs: Overflow_Analysis_Range_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overflow analysis is only available for a time period of a week or lee. Please select a short time period`)
};

const en_gb2_overflow_analysis_range_warning = /** @type {(inputs: Overflow_Analysis_Range_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill analysis is only available for a time period of a week or lee. Please select a short time period`)
};

/**
* | output |
* | --- |
* | "Overflow analysis is only available for a time period of a week or lee. Please select a short time period" |
*
* @param {Overflow_Analysis_Range_WarningInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const overflow_analysis_range_warning = /** @type {((inputs?: Overflow_Analysis_Range_WarningInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overflow_Analysis_Range_WarningInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_overflow_analysis_range_warning(inputs)
	return en_us2_overflow_analysis_range_warning(inputs)
});